let utils = require('f.component.util.pc');

/**
 * flash player的构造函数
 * @param {String} elmId    放置播放器的容器
 * @param {Object} settings 参数配置对象
 * -------------------------具体参数列表
 *
 * url:     {String}  播放地址字符串
 * width:     {Number}  播放器的宽度值
 * height:    {Number}  播放器的高度值
 * id:      {String}  播放器的id
 * version:   {Array}   *不懂是什么
 *
 */
let Player = function(container, settings) {
    this.settings = utils.merge(
        {
            url: '',
            width: 550,
            height: 309,
            id: '',
            version: [10, 0, 200]
        },
        settings
    );
    this.el = container;
    // 参数
    this.params = {};
    // 参数
    this.variables = {};
};

Player.prototype = {
    addParam: function(name, value) {
        this.params[name] = value;
    },

    addVariable: function(name, value) {
        this.variables[name] = value;
    },

    getVariables: function() {
        let a = [],
            o = this.variables;

        for (let i in o) {
            a.push(i + '=' + o[i]);
        }
        return a.join('&');
    },

    // todo: isIE并没有在此函数中声明和赋值。
    getParamString: function(isIE) {
        let a = [],
            o = this.params;
        let i;
        if (isIE) {
            for (i in o) {
                a.push('<param name="' + i + '" value="' + o[i] + '">');
            }
        } else {
            for (i in o) {
                a.push(i + '=' + o[i] + ' ');
            }
        }
        return a.join('');
    },

    addCallback: function(callbackName, method, scope) {
        scope = scope || window;
        window[callbackName] = function() {
            return method.apply(scope, arguments);
        };
    },
    // 这个应该是调用扩展吧。
    callExternal: function(movieName, method, param, mathodCallback) {
        let o = navigator.appName.indexOf('Microsoft') !== -1 ? window[movieName] : document[movieName];
        o[method](param, mathodCallback);
    },

    play: function() {
        let fls = this.getVersion(),
            v = this.settings.version;

        // 如果当前浏览器flash版本号低于设置中规定的版本
        if (parseInt(fls[0], 10) < v[0] && parseInt(fls[1], 10) < v[1] && parseInt(fls[2], 10) < v[2]) {
            this.el.innerHTML =
                '<a style="display:block;height:31px;width:190px;line-height:31px;font-size:12px;text-decoration:none;text-align:center;position:absolute;top:100px;left:410px;border:2px outset #999;" href="//get.adobe.com/flashplayer/" target="_blank">请下载最新版的flash播放器</a>';
            return;
        }

        let f = [];
        if (!!window.ActiveXObject) {
            f.push(
                '<object classid="clsid:d27cdb6e-ae6d-11cf-96b8-444553540000" codebase="//fpdownload.macromedia.com/pub/shockwave/cabs/flash/swflash.cab#version=6,0,0,0" width="'
            );
            f.push(this.settings.width);
            f.push('" height="');
            f.push(this.settings.height);
            f.push('" id="');
            f.push(this.settings.id);
            f.push('"><param name="movie" value="');
            f.push(this.settings.url);
            f.push('"><param name="flashvars" value="');
            f.push(this.getVariables());
            f.push('">');
            f.push(this.getParamString(true));
            f.push('</object>');
        } else {
            f.push('<embed pluginspage="//www.macromedia.com/go/getflashplayer" type="application/x-shockwave-flash"');
            f.push(' src="');
            f.push(this.settings.url);
            f.push('" height="');
            f.push(this.settings.height);
            f.push('" width="');
            f.push(this.settings.width);
            f.push('" id="');
            f.push(this.settings.id);
            f.push('" flashvars="');
            f.push(this.getVariables());
            f.push('" ');
            f.push(this.getParamString(false));
            f.push('>');
        }
        this.el.innerHTML = f.join('');
    },

    // 获取flash插件版本
    getVersion: function() {
        let b = [0, 0, 0];
        let c, f;
        if (navigator.plugins && navigator.mimeTypes.length) {
            let plugins = navigator.plugins['Shockwave Flash'];
            if (plugins && plugins.description) {
                return plugins.description
                    .replace(/^\D+/, '')
                    .replace(/\s*r/, '.')
                    .replace(/\s*[a-z]+\d*/, '.0')
                    .split('.');
            }
        }
        if (navigator.userAgent && navigator.userAgent.indexOf('Windows CE') !== -1) {
            c = 1;
            f = 3;
            while (c) {
                try {
                    c = new ActiveXObject('ShockwaveFlash.ShockwaveFlash.' + ++f);
                    return [f, 0, 0];
                } catch (d) {
                    c = null;
                }
            }
        }
        try {
            c = new ActiveXObject('ShockwaveFlash.ShockwaveFlash.7');
        } catch (d) {
            try {
                c = new ActiveXObject('ShockwaveFlash.ShockwaveFlash.6');
                b = [6, 0, 21];
                c.AllowScriptAccess = 'always';
            } catch (d) {
                if (b.major === 6) {
                    return b;
                }
            }
            try {
                c = new ActiveXObject('ShockwaveFlash.ShockwaveFlash');
            } catch (d) {}
        }
        if (c) {
            b = c
                .GetVariable('$version')
                .split(' ')[1]
                .split(',');
        }
        return b;
    }
};

module.exports = Player;



// WEBPACK FOOTER //
// /Users/zhujian/Desktop/code/live_system/live/modules/f.component.video.pc/app/modules/flash/index.js